import { ISelectItem } from "@/types";
import {
  IProposalStatus,
  IProposalStatusRequest,
} from "@/types/proposalStatus";

export class ProposalStatus implements IProposalStatus {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IProposalStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(member: IProposalStatus): ISelectItem {
    return {
      text: member.name,
      value: member.id,
    };
  }
}

export class ProposalStatusRequest implements IProposalStatusRequest {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IProposalStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
